import { TaskStatusWidget } from '@apps-common/apps/portal/pages/units/pages/program-tasks/components'
import { TasksQueueOptions } from '@apps-common/apps/portal/pages/units/pages/program-tasks/pages/task-queue/components'
import { CopyWithText } from '@apps-common/components/common'
import { VertSpacerSm } from '@apps-common/components/layout'
import { UnitProductCardImage } from '@apps-common/components/unit'
import { commonIcons } from '@apps-common/config/icons'
import { IUnitTaskQueueModel } from '@apps-common/types/portal/unit-tasks'

interface IProps {
  queue: IUnitTaskQueueModel
}

export const TaskQueueCard: React.FC<IProps> = (props) => {
  const { queue } = props
  const { status, productImageUrl, accountNo, mobileNo, imei, message } = queue

  return (
    <div className='bg-surface text-text border border-border rounded-3xl px-4 py-4 flex flex-col gap-[5px]'>
      <div className='flex items-center justify-between'>
        <div className='flex flex-col gap-[10px]'>
          <TaskStatusWidget status={status} />
          <div className='bg-surface-2 text-text px-4 py-2 my-2 h-[20px] rounded-[15px] flex items-center justify-start gap-[10px] min-w-0'>
            <commonIcons.processor />
            <h5 className='jost-light text-[0.85rem] uppercase'>{accountNo || <span className='text-[0.85em]'>None</span>}</h5>
          </div>
        </div>
        <UnitProductCardImage url={productImageUrl} classes='bg-surface-2' alt='Device product image' />
      </div>
      <VertSpacerSm />
      <div className='flex flex-col'>
        <div className='text-text text-[0.8em] mb-[10px] h-[40px] w-full overflow-hidden text-ellipsis'>{message}</div>

        <CopyWithText textValue='MOB' value={mobileNo} showCopyValue className='!text-[0.75rem]' />
        <CopyWithText textValue='IMEI' value={imei} showCopyValue className='!text-[0.75rem]' />
      </div>
      <VertSpacerSm />
      <TasksQueueOptions model={queue} />
    </div>
  )
}
